// Shared action categorization logic extracted from ActionMetricsTab
// Returns a human-friendly category name based on keywords in the action

const actionCategories = [
  {
    name: 'Monitoring, Alerting & Observability',
    keywords: ['monitor', 'alert', 'observability', 'grafana', 'dashboard', 'synthetic test', 'probe', 'metrics', 'tracking', 'visibility','status page']
  },
  {
    name: 'Database Performance & Optimization',
    keywords: ['database', 'db', 'query', 'sql', 'index', 'archival', 'stored procedure', 'dba', 'oracle', 'table', 'backup', 'restoration']
  },
  {
    name: 'Automation & Infrastructure Resilience',
    keywords: ['automat', 'script', 'cluster', 'infrastructure', 'resilience', 'recovery', 'hpa', 'pod', 'deployment', 'migration', 'temporal', 'autotron','infra','architecture']
  },
  {
    name: 'Change Management, Testing & Governance',
    keywords: ['change management','change process' ,'deployment', 'testing', 'validation', 'rollback', 'peer review', 'approval', 'sign-off', 'governance', 'pre-production', 'phased','renewal']
  },
  {
    name: 'Documentation, Training & Process Improvement',
    keywords: ['document', 'runbook', 'sop', 'training', 'user guideline', 'knowledge', 'process improvement', 'educate', 'rca portal', 'handover']
  }
];

export function getActionCategory(action) {
  const text = ((action.description || action.Description || '') + ' ' + (action.incidentTitle || '')).toLowerCase();

  const categoryCounts = actionCategories.map(cat => {
    let count = 0;
    for (const kw of cat.keywords) {
      const regex = new RegExp(kw.toLowerCase(), 'g');
      const matches = text.match(regex);
      if (matches) count += matches.length;
    }
    return count;
  });

  const maxCount = Math.max(...categoryCounts);
  if (maxCount === 0) return 'Uncategorized';
  const bestIndex = categoryCounts.findIndex(count => count === maxCount);
  return actionCategories[bestIndex].name;
}

export default {
  getActionCategory
};
